"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const client_1 = require("@apollo/client");
//
// assets
//
const graphql_1 = require("./graphql");
const AccountContext_1 = require("contexts/AccountContext");
//
// components
//
const Header = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Header'))));
const Editor = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Editor'))));
//
// styles
//
const Toast_1 = __importDefault(require("components/general/Toast/Toast"));
const useToast_1 = __importDefault(require("components/general/Toast/useToast"));
const TrackingPageEditor = () => {
    const editorRef = (0, react_1.useRef)({
        editor: null
    });
    const { account } = (0, AccountContext_1.useAccount)();
    const [getPage, { data: pageData }] = (0, client_1.useLazyQuery)(graphql_1.GET_PAGE, {
        fetchPolicy: 'no-cache'
    });
    const [publishTrackingPage] = (0, client_1.useMutation)(graphql_1.PUBLISH_PAGE);
    const [addFont] = (0, client_1.useMutation)(graphql_1.ADD_FONT);
    const [getFonts, { data: fontData }] = (0, client_1.useLazyQuery)(graphql_1.GET_FONTS, {
        fetchPolicy: 'no-cache'
    });
    const [getUrl] = (0, client_1.useMutation)(graphql_1.GET_ASSET_URL);
    const [getAssets, { data: assetData }] = (0, client_1.useLazyQuery)(graphql_1.GET_ASSETS, {
        fetchPolicy: 'no-cache'
    });
    const [fileString, setFileString] = (0, react_1.useState)(null);
    const [uploadComplete, setUploadComplete] = (0, react_1.useState)(false);
    const [refresh, setRefresh] = (0, react_1.useState)(false);
    const { setToastMessage, toastParams } = (0, useToast_1.default)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const searchParams = new URLSearchParams(window.location.search);
    const pageId = searchParams.get('id');
    const handleBack = (0, react_1.useCallback)(() => {
        navigate('/tracking-page/manager');
    }, [history]);
    const handleUpdateEditor = (0, react_1.useCallback)((fileData) => {
        setFileString(fileData);
    }, []);
    const handlePublish = (0, react_1.useCallback)(() => {
        publishTrackingPage({
            variables: {
                input: {
                    accountId: account === null || account === void 0 ? void 0 : account.id,
                    html: fileString,
                    id: pageId
                }
            }
        });
        setToastMessage('Changes published');
    }, [pageId, fileString]);
    const handleSave = (0, react_1.useCallback)(() => {
        setToastMessage('Changes saved');
    }, []);
    const handleAddFont = (0, react_1.useCallback)((newFont) => __awaiter(void 0, void 0, void 0, function* () {
        yield addFont({
            variables: {
                input: {
                    accountId: account === null || account === void 0 ? void 0 : account.id,
                    family: newFont.fontFamily,
                    name: newFont.fontName,
                    trackingPageId: pageId,
                    url: newFont.source,
                    weight: []
                }
            }
        });
        setRefresh(true);
        yield getFonts({
            variables: { accountId: account === null || account === void 0 ? void 0 : account.id, trackingPageId: pageId }
        });
        setRefresh(false);
        setToastMessage('Font added');
    }), [pageId]);
    function uploadFile(url, version, fileToUpload) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': fileToUpload.type,
                    'x-amz-meta-malomo-version': version
                },
                body: fileToUpload
            };
            const response = yield fetch(url, requestOptions);
            return response.status === 200;
        });
    }
    const uploadAsset = (0, react_1.useCallback)((file) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const urlData = yield getUrl({
            variables: {
                input: {
                    accountId: account === null || account === void 0 ? void 0 : account.id,
                    trackingPageId: pageId,
                    filename: file.name
                }
            }
        });
        getPage({ variables: { accountId: account === null || account === void 0 ? void 0 : account.id, id: pageId } });
        try {
            const success = yield uploadFile(urlData.data.createTrackingPageAssetSignedUrl.url, urlData.data.createTrackingPageAssetSignedUrl.version, file);
            if (!success) {
                throw new Error('Failed to upload');
            }
            const assets = yield getAssets({
                variables: { accountId: account === null || account === void 0 ? void 0 : account.id, trackingPageId: pageId }
            });
            const newAssets = assets.data.trackingPageAssets.filter((src) => {
                var _a, _b;
                return !((_b = (_a = editorRef.current.editor) === null || _a === void 0 ? void 0 : _a.AssetManager) === null || _b === void 0 ? void 0 : _b.get(src));
            });
            (_b = (_a = editorRef.current.editor) === null || _a === void 0 ? void 0 : _a.AssetManager) === null || _b === void 0 ? void 0 : _b.add(newAssets);
            setUploadComplete(true);
            setToastMessage('Image added');
        }
        catch (error) {
            setToastMessage('Error uploading image, please try again.');
        }
    }), [pageId]);
    (0, react_1.useEffect)(() => {
        if (account === null || account === void 0 ? void 0 : account.id) {
            getPage({ variables: { accountId: account === null || account === void 0 ? void 0 : account.id, id: pageId } });
            getAssets({
                variables: { accountId: account === null || account === void 0 ? void 0 : account.id, trackingPageId: pageId }
            });
            getFonts({
                variables: { accountId: account === null || account === void 0 ? void 0 : account.id, trackingPageId: pageId }
            });
        }
    }, [account === null || account === void 0 ? void 0 : account.id, pageId]);
    if (!pageData || !fontData || !assetData || refresh) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
            react_1.default.createElement(Header, { name: '', noChanges: !fileString, onBack: handleBack, onPublish: handlePublish, onSave: handleSave })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
        react_1.default.createElement(Header, { name: pageData ? pageData.trackingPage.name : '', noChanges: !fileString, onBack: handleBack, onPublish: handlePublish, onSave: handleSave }),
        react_1.default.createElement(Editor, { assetData: assetData ? assetData.trackingPageAssets : [], fonts: fontData ? fontData.trackingPageFontFaces.edges : [], htmlContent: fileString ? fileString : pageData.trackingPage.html, onAddFont: handleAddFont, onUpdateEditor: handleUpdateEditor, ref: editorRef, uploadAsset: uploadAsset, uploadComplete: uploadComplete })));
};
exports.default = TrackingPageEditor;
